import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between px-2 fill-height" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        flat: "",
        color: "white",
        height: "60px",
        class: "pt-2 mb-6",
        "extension-height": _ctx.form.status ? '30px' : '0px',
        style: {"position":"sticky","top":"0","z-index":"1000"}
      }, {
        extension: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  (_ctx.form.status === 'draft')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        size: "small",
                        variant: "outlined",
                        color: "gray",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('diary.draft')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.status === 'applied')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        size: "small",
                        variant: "outlined",
                        color: "secondary",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('diary.applied')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.status === 'approved')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 2,
                        size: "small",
                        variant: "outlined",
                        color: "primary",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('diary.approved')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_spacer),
                _createElementVNode("div", null, [
                  (_ctx.form.status === 'approved' && _ctx.approverRoles.chief)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        size: "small",
                        color: "primary",
                        class: "mb-4 mr-2 text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('diary.chief')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.form.status === 'approved' && _ctx.approverRoles.director)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        size: "small",
                        color: "primary",
                        class: "mb-4 text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('diary.director')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: {"width":"100%"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
          }, [
            _createVNode(_component_DatePager, {
              date: _ctx.date,
              onAddDay: _ctx.addDay,
              onSubtractDay: _ctx.subtractDay
            }, null, 8, ["date", "onAddDay", "onSubtractDay"])
          ])
        ]),
        _: 1
      }, 8, ["extension-height"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_VueLoading, { height: '50vh' })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_main, { class: "pa-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, {
                  fluid: "",
                  class: "py-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.form.freeRecord,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.freeRecord) = $event)),
                      label: _ctx.$t('diary.freeRecord'),
                      variant: "outlined",
                      "auto-grow": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.form.event,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.event) = $event)),
                      label: _ctx.$t('diary.event'),
                      variant: "outlined",
                      "auto-grow": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.form.earlyLeaver,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.earlyLeaver) = $event)),
                      label: _ctx.$t('diary.earlyLeaver'),
                      variant: "outlined",
                      "auto-grow": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.form.appliedBy,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.appliedBy) = $event)),
                      items: _ctx.staffList,
                      "item-title": "text",
                      "item-value": "value",
                      label: _ctx.$t('diary.applicant'),
                      variant: "outlined",
                      class: "mb-2"
                    }, null, 8, ["modelValue", "items", "label"]),
                    (_ctx.form.status === "applied" || _ctx.form.status === "approved")
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          modelValue: _ctx.form.approvedByChief,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.approvedByChief) = $event)),
                          items: _ctx.staffList,
                          "item-title": "text",
                          "item-value": "value",
                          label: _ctx.$t('diary.approverChief'),
                          variant: "outlined",
                          disabled: true,
                          class: "mb-2"
                        }, null, 8, ["modelValue", "items", "label"]))
                      : _createCommentVNode("", true),
                    (_ctx.form.status === "applied" || _ctx.form.status === "approved")
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.form.approvedByDirector,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.approvedByDirector) = $event)),
                          items: _ctx.staffList,
                          "item-title": "text",
                          "item-value": "value",
                          label: _ctx.$t('diary.approverDirector'),
                          variant: "outlined",
                          disabled: true,
                          class: "mb-2"
                        }, null, 8, ["modelValue", "items", "label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        (!_ctx.form.status || _ctx.form.status === "draft")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  variant: "outlined",
                                  onClick: _ctx.saveDraft
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('diary.saveDraft')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.form.status || _ctx.form.status === "draft")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  color: "primary",
                                  variant: "flat",
                                  onClick: _ctx.saveAndApply
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('diary.saveAndApply')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        ((_ctx.form.status === "applied" || _ctx.form.status === "approved") && _ctx.currentSchool && (_ctx.currentSchool.isChief || _ctx.currentSchool.isDirector))
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  variant: "outlined",
                                  color: "error",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeApprovalStatus('rejected')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('diary.reject')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        ((_ctx.form.status === "applied" || _ctx.form.status === "approved") && _ctx.currentSchool && (_ctx.currentSchool.isChief || _ctx.currentSchool.isDirector))
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  color: "primary",
                                  variant: "flat",
                                  disabled: _ctx.isApproveDisabled,
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeApprovalStatus('approved')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('diary.approve')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dateDialogFlg,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
        width: "auto",
        "max-width": "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_date_picker, {
                modelValue: _ctx.selectedDate,
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  _ctx.dateSelected
                ],
                type: "date",
                "day-format": (date) => new Date(date).getDate(),
                "no-title": "",
                "hide-header": "",
                color: "primary"
              }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}